/* =============================================================
   PATZU — comportamiento de las secciones personalizadas
   Se instala como assets/patzu.js
   -------------------------------------------------------------
   · Script clásico (sin módulos ES) para que funcione en Shopify
     con o sin defer, en cualquier tema.
   · No toca nada fuera de los contenedores .pz
   · Escucha los eventos del editor de temas (shopify:section:load)
     para volver a inicializarse cuando editas una sección.
   ============================================================= */
(function () {
  "use strict";

  function $(sel, scope) { return (scope || document).querySelector(sel); }
  function $$(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }
  function escHTML(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function safe(fn, name, scope) {
    try { fn(scope); } catch (e) { console.warn("[patzu:" + name + "]", e); }
  }
  var reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------------------------------------------------------
     REVEALS — umbral bajo + red de seguridad a los 6 s
     --------------------------------------------------------- */
  function initReveals(scope) {
    var items = $$(".pz-reveal:not([data-pz-revealed])", scope);
    if (!items.length) return;

    items.forEach(function (el) { el.setAttribute("data-pz-revealed", "1"); });

    if (!("IntersectionObserver" in window)) {
      items.forEach(function (el) { el.classList.add("pz-is-visible"); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add("pz-is-visible");
        if (e.target.hasAttribute("data-pz-split")) e.target.classList.add("pz-is-split-in");
        $$(".pz-mark", e.target).forEach(function (m) { m.classList.add("pz-is-drawn"); });
        io.unobserve(e.target);
      });
    }, { threshold: 0.02, rootMargin: "0px 0px -4% 0px" });

    items.forEach(function (el) { io.observe(el); });

    setTimeout(function () {
      $$(".pz-reveal:not(.pz-is-visible)").forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 1.4) {
          el.classList.add("pz-is-visible");
          if (el.hasAttribute("data-pz-split")) el.classList.add("pz-is-split-in");
        }
      });
      $$(".pz-mark:not(.pz-is-drawn)").forEach(function (m) { m.classList.add("pz-is-drawn"); });
    }, 6000);
  }

  /* ---------------------------------------------------------
     SPLIT TEXT — conserva <br> y etiquetas inline
     --------------------------------------------------------- */
  function initSplitText(scope) {
    $$("[data-pz-split]", scope).forEach(function (el) {
      if (el.dataset.pzSplitDone) return;
      el.dataset.pzSplitDone = "1";

      el.setAttribute("aria-label", el.textContent.trim().replace(/\s+/g, " "));

      var wrap = function (text) {
        return text.split(/(\s+)/).map(function (w) {
          if (/^\s*$/.test(w)) return w;
          return '<span class="pz-split-word" aria-hidden="true">' + escHTML(w) + "</span>";
        }).join("");
      };

      el.innerHTML = Array.prototype.slice.call(el.childNodes).map(function (node) {
        if (node.nodeType === 3) return wrap(node.textContent);
        if (node.nodeName === "BR") return "<br>";
        if (node.nodeType === 1) {
          var tag = node.tagName.toLowerCase();
          var cls = node.className ? ' class="' + escHTML(node.className) + '"' : "";
          return "<" + tag + cls + ">" + wrap(node.textContent) + "</" + tag + ">";
        }
        return "";
      }).join("");

      $$(".pz-split-word", el).forEach(function (w, i) {
        w.style.transitionDelay = Math.min(i * 0.035, 0.9) + "s";
      });
    });
  }

  /* ---------------------------------------------------------
     CONTADORES
     --------------------------------------------------------- */
  function initCounters(scope) {
    var nodes = $$("[data-pz-count]:not([data-pz-counted])", scope);
    if (!nodes.length) return;
    nodes.forEach(function (el) { el.setAttribute("data-pz-counted", "1"); });

    if (!("IntersectionObserver" in window)) {
      nodes.forEach(function (el) {
        el.textContent = (el.dataset.pzPrefix || "") +
          Number(el.dataset.pzCount).toLocaleString("es-PE") + (el.dataset.pzSuffix || "");
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target; io.unobserve(el);
        var end = Number(el.dataset.pzCount) || 0;
        var suf = el.dataset.pzSuffix || "";
        var pre = el.dataset.pzPrefix || "";
        var dur = 1400, t0 = null;
        function step(ts) {
          if (t0 === null) t0 = ts;
          var p = Math.min((ts - t0) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = pre + Math.round(end * eased).toLocaleString("es-PE") + suf;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.05 });

    nodes.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------
     FAQ — acordeón accesible
     --------------------------------------------------------- */
  function initFaq(scope) {
    $$("[data-pz-faq]", scope).forEach(function (list) {
      if (list.dataset.pzFaqBound) return;
      list.dataset.pzFaqBound = "1";

      $$(".pz-faq-item", list).forEach(function (item) {
        var btn = $(".pz-faq-q", item);
        var panel = $(".pz-faq-a", item);
        if (!btn || !panel) return;
        btn.addEventListener("click", function () {
          var abierto = item.classList.contains("pz-is-open");
          $$(".pz-faq-item", list).forEach(function (otro) {
            otro.classList.remove("pz-is-open");
            var b = $(".pz-faq-q", otro), p = $(".pz-faq-a", otro);
            if (b) b.setAttribute("aria-expanded", "false");
            if (p) p.style.maxHeight = "";
          });
          if (!abierto) {
            item.classList.add("pz-is-open");
            btn.setAttribute("aria-expanded", "true");
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
        });
      });
    });
  }

  /* ---------------------------------------------------------
     TESTIMONIOS — rotación automática (datos en el HTML)
     --------------------------------------------------------- */
  function initTesti(scope) {
    $$("[data-pz-testi]", scope).forEach(function (box) {
      if (box.dataset.pzTestiBound) return;
      box.dataset.pzTestiBound = "1";

      var textEl = $("[data-pz-testi-text]", box);
      var metaEl = $("[data-pz-testi-meta]", box);
      var dotsEl = $("[data-pz-testi-dots]", box);
      var fuente = $("[data-pz-testi-data]", box);
      if (!textEl || !metaEl || !dotsEl || !fuente) return;

      var items = [];
      try { items = JSON.parse(fuente.textContent) || []; } catch (e) { return; }
      if (items.length < 2) return;

      var i = 0, timer = null;

      dotsEl.innerHTML = items.map(function (_, n) {
        return '<button type="button" aria-label="Testimonio ' + (n + 1) + '"' +
               (n === 0 ? ' class="pz-is-active"' : "") + "></button>";
      }).join("");
      var dots = $$("button", dotsEl);

      function render(n) {
        box.classList.add("pz-is-fading");
        setTimeout(function () {
          var t = items[n] || {};
          textEl.textContent = "«" + (t.texto || "") + "»";
          metaEl.innerHTML = "<strong>" + escHTML(t.autor || "") + "</strong>" +
                             (t.lugar ? " · " + escHTML(t.lugar) : "");
          dots.forEach(function (d, k) { d.classList.toggle("pz-is-active", k === n); });
          box.classList.remove("pz-is-fading");
        }, 380);
      }
      function go(n) { i = (n + items.length) % items.length; render(i); restart(); }
      function restart() { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, 6500); }

      dots.forEach(function (d, n) { d.addEventListener("click", function () { go(n); }); });
      box.addEventListener("mouseenter", function () { clearInterval(timer); });
      box.addEventListener("mouseleave", restart);
      restart();
    });
  }

  /* ---------------------------------------------------------
     FILTROS DE CATÁLOGO
     --------------------------------------------------------- */
  function initFiltros(scope) {
    $$("[data-pz-filtros]", scope).forEach(function (bar) {
      if (bar.dataset.pzFiltrosBound) return;
      bar.dataset.pzFiltrosBound = "1";

      var seccion = bar.closest(".pz") || document;
      var botones = $$(".pz-filtro", bar);

      function aplicar(cat) {
        var existe = botones.some(function (b) { return b.dataset.pzFilter === cat; });
        if (!existe) cat = "todos";
        botones.forEach(function (b) { b.classList.toggle("pz-is-active", b.dataset.pzFilter === cat); });
        $$(".pz-prod", seccion).forEach(function (card) {
          var tags = (card.dataset.pzCat || "").split(" ");
          var show = cat === "todos" || tags.indexOf(cat) !== -1;
          card.classList.toggle("pz-is-hidden", !show);
        });
      }

      botones.forEach(function (b) {
        b.addEventListener("click", function () { aplicar(b.dataset.pzFilter); });
      });

      var inicial = (location.hash || "").replace("#", "");
      if (inicial) aplicar(inicial);
      window.addEventListener("hashchange", function () {
        aplicar((location.hash || "").replace("#", ""));
      });
    });
  }

  /* ---------------------------------------------------------
     PARALLAX DEL MOSAICO (solo si el tema ya carga GSAP;
     si no existe, no pasa nada)
     --------------------------------------------------------- */
  function initParallax(scope) {
    if (!window.gsap || !window.ScrollTrigger) return;
    $$(".pz-mosaic", scope).forEach(function (mosaic) {
      if (mosaic.dataset.pzParallaxBound) return;
      mosaic.dataset.pzParallaxBound = "1";
      var amp = reduced ? 3 : 8;
      var capas = [
        [$(".pz-tile--main img", mosaic), amp],
        [$(".pz-tile--b img", mosaic), -amp * 0.6],
        [$(".pz-tile--c img", mosaic), -amp * 1.2]
      ];
      capas.forEach(function (par) {
        if (!par[0]) return;
        gsap.to(par[0], {
          yPercent: par[1], scale: 1.07, ease: "none",
          scrollTrigger: { trigger: mosaic, start: "top bottom", end: "bottom top", scrub: 0.75 }
        });
      });
    });
  }


  /* ---------------------------------------------------------
     CARRUSEL — flechas sobre scroll nativo (sin librerías)
     --------------------------------------------------------- */
  function initCarrusel(scope) {
    $$("[data-pz-carrusel]", scope).forEach(function (caja) {
      if (caja.dataset.pzCarruselBound) return;
      caja.dataset.pzCarruselBound = "1";

      var pista = $(".pz-pista", caja);
      var prev = $("[data-pz-prev]", caja);
      var next = $("[data-pz-next]", caja);
      if (!pista) return;

      function paso() {
        var item = pista.firstElementChild;
        if (!item) return pista.clientWidth * 0.8;
        var gap = parseFloat(getComputedStyle(pista).columnGap || "16") || 16;
        return item.getBoundingClientRect().width + gap;
      }
      function refrescar() {
        if (!prev || !next) return;
        var max = pista.scrollWidth - pista.clientWidth - 2;
        prev.disabled = pista.scrollLeft <= 2;
        next.disabled = pista.scrollLeft >= max;
      }
      if (prev) prev.addEventListener("click", function () { pista.scrollBy({ left: -paso(), behavior: "smooth" }); });
      if (next) next.addEventListener("click", function () { pista.scrollBy({ left: paso(), behavior: "smooth" }); });

      pista.addEventListener("scroll", function () {
        clearTimeout(pista._pzT);
        pista._pzT = setTimeout(refrescar, 90);
      }, { passive: true });
      window.addEventListener("resize", refrescar);
      refrescar();

      /* ---- Avance automatico ----
         Se activa con data-pz-auto="4000" (milisegundos).
         Se detiene solo cuando: el cursor esta encima, el dedo toca la
         pista, la pestana no esta visible, el carrusel salio de pantalla
         o el sistema pide menos movimiento. */
      var espera = parseInt(caja.dataset.pzAuto || "0", 10);
      if (!espera || reduced) return;

      var reloj = null, pausado = false, aLaVista = true;

      function avanzar() {
        if (pausado || !aLaVista || document.hidden) return;
        var max = pista.scrollWidth - pista.clientWidth - 2;
        if (pista.scrollLeft >= max) {
          pista.scrollTo({ left: 0, behavior: "smooth" });
        } else {
          pista.scrollBy({ left: paso(), behavior: "smooth" });
        }
      }
      function arrancar() { if (!reloj) reloj = setInterval(avanzar, espera); }
      function parar() { clearInterval(reloj); reloj = null; }

      ["mouseenter", "focusin", "touchstart", "pointerdown"].forEach(function (ev) {
        caja.addEventListener(ev, function () { pausado = true; }, { passive: true });
      });
      ["mouseleave", "focusout", "touchend"].forEach(function (ev) {
        caja.addEventListener(ev, function () { pausado = false; }, { passive: true });
      });
      document.addEventListener("visibilitychange", function () {
        if (document.hidden) { parar(); } else { arrancar(); }
      });

      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (entradas) {
          entradas.forEach(function (e) {
            aLaVista = e.isIntersecting;
            if (aLaVista) { arrancar(); } else { parar(); }
          });
        }, { threshold: 0.2 }).observe(caja);
      } else {
        arrancar();
      }
    });
  }

  /* ---------------------------------------------------------
     VIDEO — solo reproduce cuando está a la vista.
     Ahorra datos y batería, y no bloquea la carga inicial.
     --------------------------------------------------------- */
  function initVideo(scope) {
    var ahorro = navigator.connection && (navigator.connection.saveData ||
                 /2g/.test(navigator.connection.effectiveType || ""));

    $$("[data-pz-video]", scope).forEach(function (video) {
      if (video.dataset.pzVideoBound) return;
      video.dataset.pzVideoBound = "1";

      /* Si no se puede reproducir solo (ahorro de datos, movimiento
         reducido o el telefono bloquea la reproduccion automatica, como
         el modo ahorro de bateria del iPhone): se muestra el primer
         cuadro del video y sus controles para que el cliente lo toque.
         Antes quedaba un recuadro negro. */
      function sinAutoplay() {
        if (video.dataset.pzSrc && !video.getAttribute("src")) {
          video.preload = "metadata";
          video.src = video.dataset.pzSrc + "#t=0.1";
        }
        video.controls = true;
      }

      if (ahorro || reduced) { video.removeAttribute("autoplay"); sinAutoplay(); return; }

      if (!("IntersectionObserver" in window)) { video.play().catch(function () {}); return; }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            if (video.dataset.pzSrc && !video.getAttribute("src")) video.src = video.dataset.pzSrc;
            var intento = video.play();
            if (intento && intento.catch) intento.catch(sinAutoplay);
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.25 });
      io.observe(video);

      var boton = video.parentElement && $("[data-pz-sonido]", video.parentElement);
      if (boton) {
        boton.addEventListener("click", function () {
          video.muted = !video.muted;
          boton.setAttribute("aria-pressed", video.muted ? "false" : "true");
          $$("[data-pz-icono-on], [data-pz-icono-off]", boton).forEach(function (i) {
            i.hidden = i.hasAttribute("data-pz-icono-on") ? video.muted : !video.muted;
          });
          if (!video.muted) video.play().catch(function () {});
        });
      }
    });
  }

  /* ---------------------------------------------------------
     BLOQUE SEO PLEGABLE
     --------------------------------------------------------- */
  function initSeo(scope) {
    $$("[data-pz-seo]", scope).forEach(function (caja) {
      if (caja.dataset.pzSeoBound) return;
      caja.dataset.pzSeoBound = "1";
      var btn = $("[data-pz-seo-mas]", caja);
      var cuerpo = $(".pz-seo-cuerpo", caja);
      if (!btn || !cuerpo) return;

      // Si el texto es corto no hace falta el botón
      if (cuerpo.scrollHeight <= cuerpo.clientHeight + 8) {
        btn.hidden = true;
        cuerpo.style.maxHeight = "none";
        caja.classList.add("pz-is-open");
        return;
      }

      btn.addEventListener("click", function () {
        var abierto = caja.classList.toggle("pz-is-open");
        btn.setAttribute("aria-expanded", abierto ? "true" : "false");
        $$("[data-pz-seo-txt]", btn).forEach(function (t) {
          t.textContent = abierto ? (btn.dataset.pzMenos || "Leer menos")
                                  : (btn.dataset.pzMas || "Leer más");
        });
      });
    });
  }

  /* ---------------------------------------------------------
     BAJAR — lleva al primer bloque de contenido de la ficha
     --------------------------------------------------------- */
  function initBajar(scope) {
    $$("[data-pz-bajar]:not([data-pz-bajar-listo])", scope).forEach(function (b) {
      b.setAttribute("data-pz-bajar-listo", "1");
      b.addEventListener("click", function () {
        var destino = document.querySelector(b.dataset.pzBajar || ".pz-row, .pz-section, .pz-block");
        if (!destino) return;
        destino.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  }

  /* ---------------------------------------------------------
     CTA — red de seguridad del boton de compra

     El boton de la ficha sale con href="/rsi-btn-overwrite".
     Ese href no es un destino: es la senal que el script de
     Releasit busca para convertirlo en el boton que abre el
     formulario (le pone href="#" y le anade sus clases).

     Si por lo que sea ese script no llega a correr, el enlace
     se quedaria apuntando a una URL que no existe y el cliente
     acabaria en un 404. Esta funcion espera, y si al cabo de un
     rato nadie lo toco, lo neutraliza.
     --------------------------------------------------------- */
  function initCtaSeguro() {
    var SENAL = "/rsi-btn-overwrite";
    if (!document.querySelector('[href="' + SENAL + '"]')) return;
    setTimeout(function () {
      $$('[href="' + SENAL + '"]').forEach(function (a) {
        a.setAttribute("href", "#");
        a.setAttribute("aria-disabled", "true");
      });
    }, 6000);
  }

  /* ---------------------------------------------------------
     MURO — el boton de ver mas resenas

     Las tarjetas de sobra salen del servidor con el atributo
     hidden puesto. Si el JS no llega a correr se ven las
     primeras y nada mas: no hay pantalla rota, solo menos
     resenas.
     --------------------------------------------------------- */
  function initMuro(scope) {
    $$("[data-pz-muro-mas]:not([data-pz-muro-listo])", scope).forEach(function (btn) {
      btn.setAttribute("data-pz-muro-listo", "1");
      var muro = btn.closest(".pz-muro");
      if (!muro) return;

      var extra = $$("[data-pz-muro-extra]", muro);
      if (!extra.length) { btn.parentNode.hidden = true; return; }

      btn.addEventListener("click", function () {
        extra.forEach(function (el) { el.hidden = false; });
        btn.parentNode.hidden = true;
      });
    });
  }

  /* ---------------------------------------------------------
     GALERIA — carrusel de fotos con miniaturas

     El movimiento lo hace scroll-snap, no JavaScript: el dedo
     arrastra solo y el navegador se encarga de encajar. Aqui solo
     se atienden las flechas, las miniaturas y el contador.
     --------------------------------------------------------- */
  function initGaleria(scope) {
    $$("[data-pz-galeria]:not([data-pz-galeria-listo])", scope).forEach(function (raiz) {
      raiz.setAttribute("data-pz-galeria-listo", "1");

      var pista = $(".pzl-gal-pista", raiz);
      if (!pista) return;

      var tira = $(".pzl-gal-minis", raiz);
      var minis = $$("[data-pz-gal-ir]", raiz);
      var ahora = $("[data-pz-gal-ahora]", raiz);
      var total = pista.children.length;
      var actual = 0;
      var pendiente = false;

      function ir(i) {
        i = (i + total) % total;
        // scrollLeft a pelo, sin scrollTo({behavior}): sobre un
        // contenedor con scroll-snap mandatory el desplazamiento
        // suave por JS se cancela y vuelve al sitio. La animacion
        // la pone scroll-behavior en el CSS, que si lo respeta.
        pista.scrollLeft = i * pista.clientWidth;
        marcar(i);
      }

      function marcar(i) {
        if (i === actual) return;
        if (minis[actual]) minis[actual].removeAttribute("aria-current");
        actual = i;
        var m = minis[i];
        if (m && tira) {
          m.setAttribute("aria-current", "true");
          tira.scrollLeft = m.offsetLeft - (tira.clientWidth - m.offsetWidth) / 2;
        }
        if (ahora) ahora.textContent = i + 1;
      }

      pista.addEventListener("scroll", function () {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(function () {
          pendiente = false;
          var i = Math.round(pista.scrollLeft / pista.clientWidth);
          marcar(Math.max(0, Math.min(total - 1, i)));
        });
      }, { passive: true });

      raiz.addEventListener("click", function (e) {
        var btn = e.target.closest("button");
        if (!btn || !raiz.contains(btn)) return;
        // getAttribute y no dataset: el indice 0 existe y hay que
        // distinguirlo de "no tiene el atributo"
        var dir = btn.getAttribute("data-pz-gal-dir");
        var destino = btn.getAttribute("data-pz-gal-ir");
        if (dir !== null) ir(actual + parseInt(dir, 10));
        else if (destino !== null) ir(parseInt(destino, 10));
      });
    });
  }

  /* ---------------------------------------------------------
     TESTIMONIOS — carrusel con puntos

     Cada carrusel guarda su estado en su propio ambito, asi que
     pueden convivir varios en la misma pagina. El original del
     que sale esto colgaba la funcion de window y buscaba la
     pista por id, de modo que el segundo carrusel movia al
     primero.
     --------------------------------------------------------- */
  function initTesti2(scope) {
    $$("[data-pz-testi]:not([data-pz-testi-listo])", scope).forEach(function (raiz) {
      raiz.setAttribute("data-pz-testi-listo", "1");

      var pista = $("[data-pz-testi-pista]", raiz);
      if (!pista) return;

      var puntos = $$("[data-pz-testi-ir]", raiz);
      var total = pista.children.length;
      if (total < 2) return;

      var actual = 0;
      var reloj = null;
      var espera = parseInt(raiz.getAttribute("data-pz-testi-auto"), 10) || 0;

      function mostrar(i) {
        actual = (i + total) % total;
        pista.style.transform = "translateX(-" + (actual * 100) + "%)";
        puntos.forEach(function (p, n) {
          if (n === actual) p.setAttribute("aria-current", "true");
          else p.removeAttribute("aria-current");
        });
      }

      function arrancar() {
        if (!espera || reduced) return;
        parar();
        reloj = setInterval(function () { mostrar(actual + 1); }, espera);
      }
      function parar() { if (reloj) { clearInterval(reloj); reloj = null; } }

      puntos.forEach(function (p) {
        p.addEventListener("click", function () {
          mostrar(parseInt(p.getAttribute("data-pz-testi-ir"), 10));
          arrancar();
        });
      });

      // Se para mientras se lee: con el raton encima o con el
      // teclado dentro. Cambiar de tarjeta a media frase es lo
      // que mas molesta de un carrusel automatico.
      raiz.addEventListener("mouseenter", parar);
      raiz.addEventListener("mouseleave", arrancar);
      raiz.addEventListener("focusin", parar);
      raiz.addEventListener("focusout", arrancar);

      // Arrastre con el dedo
      var inicioX = 0;
      raiz.addEventListener("touchstart", function (e) {
        inicioX = e.touches[0].clientX;
        parar();
      }, { passive: true });
      raiz.addEventListener("touchend", function (e) {
        var salto = inicioX - e.changedTouches[0].clientX;
        if (Math.abs(salto) > 40) mostrar(actual + (salto > 0 ? 1 : -1));
        arrancar();
      }, { passive: true });

      arrancar();
    });
  }

  /* ---------------------------------------------------------
     RESENAS: FILA QUE AVANZA SOLA Y SE PUEDE DESLIZAR
     La fila es un scroll normal, asi que el dedo, el trackpad y
     la rueda funcionan solos, con su inercia. Aqui se hacen tres
     cosas:
     · Avanzar despacio mientras nadie la toca.
     · Quedarse quieta mientras alguien la toca, la desliza, tiene
       el raton encima o esta dentro con el teclado, y seguir
       DESCANSO ms despues de que la suelta, desde donde quedo.
     · Que no se acabe: hay tres tandas identicas y, en reposo, el
       scroll se recoloca en la del medio sin que se note.
     Arrastrar con el raton tambien la mueve (en PC no hay dedo).
     --------------------------------------------------------- */
  function initResenas(scope) {
    $$("[data-pz-resenas]:not([data-pz-resenas-listo])", scope).forEach(function (raiz) {
      raiz.setAttribute("data-pz-resenas-listo", "1");

      var v = $("[data-pz-resenas-ventana]", raiz);
      var originales = $$("[data-original]", raiz);
      if (!v || !originales.length) return;

      var VEL = parseFloat(raiz.getAttribute("data-pz-resenas-vel")) || 30; // px por segundo
      var DESCANSO = 2500;  // ms sin tocarla antes de que siga
      var MARGEN = 16;      // aire a la izquierda al arrancar

      var tanda = 0;        // ancho de una tanda completa
      var pos = 0;          // posicion exacta (scrollLeft redondea)
      var puesto = -1;      // ultimo scrollLeft que puso este script
      var ultimaMano = -1e9;
      var pendiente = false;
      var presionado = false, encima = false, visible = true;
      var antes = 0;

      function inicio() { return originales[0].offsetLeft; }
      function medir() {
        var sig = originales[originales.length - 1].nextElementSibling;
        tanda = sig ? sig.offsetLeft - inicio() : 0;
      }
      function poner(x) { pos = x; v.scrollLeft = x; puesto = v.scrollLeft; }
      function tocar() { ultimaMano = performance.now(); pendiente = true; }

      // Lleva el scroll a la tanda del medio (las tres son iguales).
      function recentrar() {
        if (!tanda) return;
        var x = v.scrollLeft, ini = inicio();
        while (x < ini - tanda / 2) x += tanda;
        while (x > ini + tanda / 2) x -= tanda;
        if (Math.abs(x - v.scrollLeft) > 1) poner(x);
      }

      function paso(t) {
        if (!raiz.isConnected) return;
        requestAnimationFrame(paso);
        var dt = antes ? Math.min(t - antes, 64) : 0;
        antes = t;
        // Si la fila no esta donde la dejo el script, la movio la
        // persona (aunque el evento scroll aun no haya llegado).
        if (puesto >= 0 && Math.abs(v.scrollLeft - puesto) > 1) {
          pos = v.scrollLeft; puesto = pos; tocar(); return;
        }
        if (reduced || presionado || encima || !visible || !tanda) return;
        if (t - ultimaMano < DESCANSO) return;
        if (pendiente) { recentrar(); pos = v.scrollLeft; pendiente = false; }
        pos += VEL * dt / 1000;
        if (pos > inicio() + tanda / 2) pos -= tanda;
        v.scrollLeft = pos;
        puesto = v.scrollLeft;
      }

      // Cualquier scroll que no puso este script es de la persona.
      v.addEventListener("scroll", function () {
        if (Math.abs(v.scrollLeft - puesto) > 1) { pos = v.scrollLeft; tocar(); }
      }, { passive: true });

      // Dedo o raton apoyado
      var arrastre = null;
      v.addEventListener("pointerdown", function (e) {
        presionado = true; tocar();
        if (e.pointerType === "mouse" && e.button === 0) {
          recentrar();
          arrastre = { x: e.clientX, s: v.scrollLeft, movido: false };
          v.setPointerCapture(e.pointerId);
        }
      });
      v.addEventListener("pointermove", function (e) {
        if (!arrastre) return;
        var dx = e.clientX - arrastre.x;
        if (!arrastre.movido && Math.abs(dx) > 4) {
          arrastre.movido = true;
          raiz.classList.add("is-arrastrando");
        }
        if (arrastre.movido) { v.scrollLeft = arrastre.s - dx; tocar(); }
      });
      function soltar() {
        presionado = false; tocar();
        if (arrastre) { arrastre = null; raiz.classList.remove("is-arrastrando"); }
      }
      v.addEventListener("pointerup", soltar);
      v.addEventListener("pointercancel", soltar);

      // Leyendo con el raton encima o con el teclado dentro
      raiz.addEventListener("mouseenter", function () { encima = true; });
      raiz.addEventListener("mouseleave", function () { encima = false; tocar(); });
      v.addEventListener("focusin", function () { encima = true; });
      v.addEventListener("focusout", function () { encima = false; tocar(); });
      v.addEventListener("keydown", function (e) {
        if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
          e.preventDefault();
          ir(e.key === "ArrowRight" ? 1 : -1);
        }
      });

      // Flechas (solo se ven en PC)
      function ir(dir) {
        recentrar(); tocar();
        var card = originales[0];
        var paso1 = card.offsetWidth + parseFloat(getComputedStyle(card).marginRight || 0);
        v.scrollBy({ left: dir * paso1, behavior: reduced ? "auto" : "smooth" });
      }
      $$("[data-pz-resenas-ir]", raiz).forEach(function (b) {
        b.addEventListener("click", function () { ir(parseInt(b.getAttribute("data-pz-resenas-ir"), 10)); });
      });

      // Fuera de pantalla no se mueve: ahorra bateria.
      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (entradas) {
          entradas.forEach(function (en) { visible = en.isIntersecting; });
        }, { rootMargin: "80px 0px" }).observe(raiz);
      }

      // Al cambiar el ancho (girar el celular) las tarjetas cambian de tamano.
      var anchoAntes = window.innerWidth;
      window.addEventListener("resize", function () {
        if (window.innerWidth === anchoAntes) return;
        anchoAntes = window.innerWidth;
        medir(); poner(inicio() - MARGEN);
      }, { passive: true });

      medir();
      poner(inicio() - MARGEN);
      requestAnimationFrame(paso);
    });
  }

  /* ---------------------------------------------------------
     CARRUSEL "COVERFLOW" (la formula, tarjetas con foto)
     Todas las tarjetas ocupan la misma celda; cada una se coloca
     segun su distancia a la activa: al centro grande, a los lados
     mas chicas y transparentes. Avanza solo en bucle; se pausa al
     tocar, deslizar o con el raton encima y sigue a los 4 s.
     --------------------------------------------------------- */
  function initPartesCf(scope) {
    $$("[data-pz-partes-cf]:not([data-pz-cf-listo])", scope).forEach(function (raiz) {
      raiz.setAttribute("data-pz-cf-listo", "1");
      var cards = $$(".pzl-partes-card--foto", raiz);
      var puntos = $$("[data-pz-cf-ir]", raiz);
      var n = cards.length;
      if (n < 2) return;

      var RITMO = parseInt(raiz.getAttribute("data-pz-cf-ritmo"), 10) || 3000;
      var actual = 0, reloj = null, espera = null, visible = true, mano = false, arrastro = false;
      var previo = cards.map(function () { return 0; });

      function dist(i) {
        var d = i - actual;
        if (d > n / 2) d -= n;
        if (d < -n / 2) d += n;
        return d;
      }
      function pintar() {
        var paso = window.innerWidth >= 990 ? 80 : 84;
        cards.forEach(function (c, i) {
          var d = dist(i), a = Math.abs(d);
          // Si cambia de lado (vuelta del bucle) no se anima: cruzaria por el centro
          c.style.transition = Math.abs(d - previo[i]) > 2 ? "none" : "";
          previo[i] = d;
          c.style.transform = "translateX(" + (d * paso) + "%) scale(" + (a === 0 ? 1 : a === 1 ? 0.84 : 0.7) + ")";
          c.style.opacity = a === 0 ? 1 : a === 1 ? 0.55 : a === 2 ? 0.22 : 0;
          c.style.zIndex = 10 - a;
          c.style.pointerEvents = a > 1 ? "none" : "";
          c.classList.toggle("is-activa", d === 0);
          c.setAttribute("aria-hidden", d === 0 ? "false" : "true");
        });
        puntos.forEach(function (p, k) { p.setAttribute("aria-current", k === actual ? "true" : "false"); });
      }
      function ir(i) { actual = (i + n) % n; pintar(); }
      function tocar() {
        mano = true;
        clearTimeout(espera);
        espera = setTimeout(function () { mano = false; }, 4000);
      }

      cards.forEach(function (c, i) {
        c.addEventListener("click", function () {
          if (arrastro) { arrastro = false; return; }
          if (dist(i) !== 0) { ir(i); tocar(); }
        });
      });
      puntos.forEach(function (p, k) {
        p.addEventListener("click", function () { ir(k); tocar(); });
      });

      // Deslizar con el dedo o arrastrar con el raton
      var x0 = null;
      raiz.addEventListener("pointerdown", function (e) { x0 = e.clientX; mano = true; clearTimeout(espera); });
      raiz.addEventListener("pointerup", function (e) {
        if (x0 === null) return;
        var dx = e.clientX - x0; x0 = null;
        if (Math.abs(dx) > 35) { arrastro = true; ir(actual + (dx < 0 ? 1 : -1)); setTimeout(function () { arrastro = false; }, 50); }
        tocar();
      });
      raiz.addEventListener("pointercancel", function () { x0 = null; tocar(); });
      raiz.addEventListener("mouseenter", function () { mano = true; clearTimeout(espera); });
      raiz.addEventListener("mouseleave", tocar);

      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { visible = e.isIntersecting; });
        }, { threshold: 0.3 }).observe(raiz);
      }
      window.addEventListener("resize", pintar, { passive: true });

      pintar();
      if (!reduced) {
        reloj = setInterval(function () {
          if (!mano && visible && !document.hidden && raiz.isConnected) ir(actual + 1);
          if (!raiz.isConnected) clearInterval(reloj);
        }, RITMO);
      }
    });
  }

  /* ---------------------------------------------------------
     CIFRAS QUE CUENTAN AL APARECER
     Cada numero dentro del texto ("2–3", "2 min", "~50", "0 %")
     cuenta desde 0 hasta su valor; lo que no es numero se queda
     igual. La cifra final ya esta en el HTML: aqui solo se pone en
     cero mientras la seccion no se ha visto.
     --------------------------------------------------------- */
  function initCifras(scope) {
    $$("[data-pz-cifras]:not([data-pz-cifras-listo])", scope).forEach(function (caja) {
      caja.setAttribute("data-pz-cifras-listo", "1");
      var nums = $$("[data-pz-cifra]", caja);
      if (reduced || !("IntersectionObserver" in window)) { caja.classList.add("is-visto"); return; }

      /* El numero final se queda puesto en el HTML hasta que la seccion
         se ve: recien ahi se pone en cero y cuenta. Antes se ponia en
         cero al cargar y, si el aviso de "ya se ve" no llegaba (ahorro de
         bateria, captura de pagina completa), se quedaba en "0". */
      var finales = nums.map(function (n) { return n.textContent; });

      function contar(n, final, retraso) {
        var DUR = 1300, t0 = null;
        function paso(t) {
          if (t0 === null) t0 = t;
          var p = Math.min(1, Math.max(0, (t - t0 - retraso) / DUR));
          var e = 1 - Math.pow(1 - p, 3);
          n.textContent = final.replace(/\d+/g, function (m) { return String(Math.round(parseInt(m, 10) * e)); });
          if (p < 1) requestAnimationFrame(paso); else n.textContent = final;
        }
        requestAnimationFrame(paso);
        /* Red de seguridad: si el navegador frena la animacion, el
           numero final igual queda puesto */
        setTimeout(function () { n.textContent = final; }, DUR + retraso + 600);
      }

      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.disconnect();
          caja.classList.add("is-visto");
          nums.forEach(function (n, k) {
            n.textContent = finales[k].replace(/\d+/g, "0");
            contar(n, finales[k], 150 + k * 140);
          });
        });
      }, { threshold: 0.2 });
      io.observe(caja);
    });
  }

  /* ---------------------------------------------------------
     ARRANQUE
     --------------------------------------------------------- */
  /* ---------------------------------------------------------
     ANTES Y DESPUES — copia el valor del deslizador a --pos
     --------------------------------------------------------- */
  function initAntesDespues(scope) {
    $$("[data-pz-ad]:not([data-pz-ad-listo])", scope).forEach(function (caja) {
      caja.setAttribute("data-pz-ad-listo", "1");
      var rango = $(".pzl-ad-rango", caja);
      if (!rango) return;
      function pinta() { caja.style.setProperty("--pos", rango.value + "%"); }
      rango.addEventListener("input", pinta);
      pinta();
    });
  }

  /* ---------------------------------------------------------
     AHORRO — misma formula que el Liquid de la seccion:
     cortes al ano = 52 / semanas, redondeado hacia abajo.
     --------------------------------------------------------- */
  function initAhorro(scope) {
    $$("[data-pz-ahorro]:not([data-pz-ahorro-listo])", scope).forEach(function (caja) {
      caja.setAttribute("data-pz-ahorro-listo", "1");
      var prod = parseFloat(caja.getAttribute("data-producto")) || 0;
      var precio = $('input[type="number"]', caja);
      var anual = $("[data-pz-ah-anual]", caja);
      var cortes = $("[data-pz-ah-cortes]", caja);
      var final = $("[data-pz-ah-final]", caja);
      function soles(n) { return "S/ " + Math.round(n); }
      function calcula() {
        var marcado = $('input[type="radio"]:checked', caja);
        var semanas = marcado ? parseInt(marcado.value, 10) : 4;
        var visita = parseFloat(String(precio.value).replace(",", ".")) || 0;
        var c = Math.floor(52 / semanas);
        var gasto = c * visita;
        var ahorro = Math.round(gasto - prod);
        anual.textContent = soles(gasto);
        cortes.textContent = c + " cortes al año";
        if (visita > 0 && ahorro > 0) {
          final.innerHTML = "Se paga solo desde el corte n.º <b>" + Math.ceil(prod / visita) +
            "</b> y el primer año te ahorras <b>" + soles(ahorro) + "</b>.";
        } else {
          final.textContent = "Además del dinero, te ahorras el viaje y el estrés de tu mascota.";
        }
      }
      caja.addEventListener("change", calcula);
      precio.addEventListener("input", calcula);
      calcula();
    });
  }

  /* ---------------------------------------------------------
     COMPRAR — el boton de la oferta final abre el formulario de
     Releasit pulsando su boton de la columna de compra. Si aun no
     cargo, sube hasta la columna de compra.
     --------------------------------------------------------- */
  function initComprar(scope) {
    $$("[data-pz-comprar]:not([data-pz-comprar-listo])", scope).forEach(function (btn) {
      btn.setAttribute("data-pz-comprar-listo", "1");
      btn.addEventListener("click", function () {
        if (window.pzAbrirReleasit && window.pzAbrirReleasit()) return;
        var rsi = $("#_rsi-buy-now-button-floating #_rsi-buy-now-button") ||
                  $(".rsi-app-block-container ._rsi-buy-now-button") ||
                  $("._rsi-buy-now-button-floating ._rsi-buy-now-button") ||
                  $("._rsi-buy-now-button");
        if (rsi) { rsi.click(); return; }
        var destino = $(".rsi-app-block-container") || $(".pz-row");
        if (destino) destino.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    });
  }

  /* ---------------------------------------------------------
     ANATOMIA — punto sobre el aparato y tarjeta de cada parte
     van juntos. Recorre las partes sola mientras la seccion se
     ve; al tocar, deslizar o pasar el raton se detiene y retoma
     a los 6 s. En celular las tarjetas son una fila deslizable.
     --------------------------------------------------------- */
  function initAnatomia(scope) {
    $$("[data-pz-anat]:not([data-pz-anat-listo])", scope).forEach(function (sec) {
      sec.setAttribute("data-pz-anat-listo", "1");
      var cards = $$("[data-pz-anat-card]", sec);
      var puntos = $$("[data-pz-anat-punto]", sec);
      var fila = $(".pzl-anat-cards", sec);
      var cont = $("[data-pz-anat-cont]", sec);
      var barra = $(".pzl-anat-barra i", sec);
      var n = cards.length;
      if (!n || !fila) return;

      var ritmo = (parseFloat(sec.getAttribute("data-ritmo")) || 4) * 1000;
      var movil = window.matchMedia("(max-width: 989px)");
      var quieto = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var activo = 0, pausaHasta = 0, visible = false, desdeCodigo = 0, reloj = null;

      function dos(x) { return (x < 10 ? "0" : "") + x; }

      function reiniciaBarra() {
        if (!barra) return;
        barra.style.animation = "none";
        void barra.offsetWidth;
        barra.style.animation = "";
      }

      function centra(i) {
        if (!movil.matches) return;
        var c = cards[i];
        desdeCodigo = Date.now();
        fila.scrollTo({ left: c.offsetLeft - (fila.clientWidth - c.offsetWidth) / 2, behavior: quieto ? "auto" : "smooth" });
      }

      function activa(i, mover) {
        i = (i + n) % n;
        activo = i;
        cards.forEach(function (c, k) {
          c.classList.toggle("is-activo", k === i);
          var b = $(".pzl-anat-btn", c);
          if (b) b.setAttribute("aria-pressed", k === i ? "true" : "false");
        });
        puntos.forEach(function (p, k) { p.classList.toggle("is-activo", k === i); });
        if (cont) cont.textContent = dos(i + 1) + " / " + dos(n);
        reiniciaBarra();
        if (mover) centra(i);
        programa(ritmo);
      }

      function programa(ms) {
        clearTimeout(reloj);
        if (!quieto) reloj = setTimeout(tic, ms);
      }

      function pausa() {
        pausaHasta = Date.now() + 6000;
        sec.classList.add("is-pausa");
      }

      /* La barra marca el tiempo que falta: tras una pausa vuelve a
         empezar entera y recien al llenarse pasa a la siguiente. */
      function tic() {
        var ahora = Date.now();
        if (ahora < pausaHasta) { programa(pausaHasta - ahora); return; }
        if (sec.classList.contains("is-pausa")) {
          sec.classList.remove("is-pausa");
          reiniciaBarra();
          programa(ritmo);
          return;
        }
        if (!visible || document.hidden) { programa(ritmo); return; }
        activa(activo + 1, true);
      }

      cards.forEach(function (c, k) {
        c.addEventListener("click", function () { pausa(); activa(k, true); });
        c.addEventListener("mouseenter", function () {
          if (movil.matches) return;
          pausa(); if (k !== activo) activa(k, false);
        });
      });
      puntos.forEach(function (p, k) {
        p.addEventListener("click", function () { pausa(); activa(k, true); });
      });
      $$("[data-pz-anat-dir]", sec).forEach(function (b) {
        b.addEventListener("click", function () {
          pausa(); activa(activo + parseInt(b.getAttribute("data-pz-anat-dir"), 10), true);
        });
      });

      /* Deslizar con el dedo: la tarjeta mas centrada pasa a ser la activa */
      var espera = null;
      fila.addEventListener("scroll", function () {
        if (!movil.matches) return;
        clearTimeout(espera);
        espera = setTimeout(function () {
          var centro = fila.scrollLeft + fila.clientWidth / 2, mejor = 0, dist = Infinity;
          cards.forEach(function (c, k) {
            var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - centro);
            if (d < dist) { dist = d; mejor = k; }
          });
          if (Date.now() - desdeCodigo > 900) pausa();
          if (mejor !== activo) activa(mejor, false);
        }, 120);
      }, { passive: true });

      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (e) {
          visible = e[0].isIntersecting;
          sec.classList.toggle("is-visto", visible || sec.classList.contains("is-visto"));
          if (visible && Date.now() >= pausaHasta) { reiniciaBarra(); programa(ritmo); }
        }, { threshold: 0.25 }).observe(sec);
      } else {
        visible = true;
      }

      if (quieto) sec.classList.add("is-pausa");
      activa(0, false);
    });
  }

  /* ---------------------------------------------------------
     ENSAMBLE — la seccion es alta y su interior queda fijo.
     El avance del scroll (0 a 1) se reparte en escenas:
     presentacion, una por pieza y el final. Cada pieza entra
     desde lejos en su escena y queda separada; en el final
     todas vuelven a su lugar y se arma el producto.
     --------------------------------------------------------- */
  function initEnsamble(scope) {
    $$("[data-pz-ens]:not([data-pz-ens-listo])", scope).forEach(function (sec) {
      sec.setAttribute("data-pz-ens-listo", "1");
      var piezas = $$("[data-pz-ens-pieza]", sec);
      var escenas = $$("[data-pz-ens-escena]", sec);
      var pasos = $$("[data-pz-ens-ir]", sec);
      var etq = $("[data-pz-ens-etq]", sec);
      var fantasma = $(".pzl-ens-fantasma", sec);
      var fotoFinal = $("[data-pz-ens-final]", sec);
      var n = piezas.length, T = escenas.length;
      if (!T) return;

      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        sec.classList.add("is-quieto");
        return;
      }
      sec.classList.add("is-vivo");

      var d = piezas.map(function (p) {
        return {
          x: parseFloat(p.getAttribute("data-x")) || 0,
          y: parseFloat(p.getAttribute("data-y")) || 0,
          r: parseFloat(p.getAttribute("data-r")) || 0,
          izq: parseFloat(p.getAttribute("data-izq")) || 0,
          der: parseFloat(p.getAttribute("data-der")) || 100,
          cy: parseFloat(p.getAttribute("data-cy")) || 50,
          sup: parseFloat(p.getAttribute("data-sup")) || 0,
          etq: p.getAttribute("data-etq") || ""
        };
      });

      /* La cabecera de la tienda es fija: el interior se ancla justo debajo */
      function cabecera() {
        var h = document.querySelector(".shopify-section-group-header-group");
        var alto = 0;
        if (h) {
          var cs = getComputedStyle(h);
          if (cs.position === "sticky" || cs.position === "fixed") alto = Math.max(0, h.getBoundingClientRect().bottom);
        }
        sec.style.setProperty("--ens-arriba", Math.round(alto) + "px");
      }

      function lim(v, a, b) { return v < a ? a : v > b ? b : v; }
      function suave(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

      var actual = -1, pedido = false;

      function pinta() {
        pedido = false;
        var caja = sec.getBoundingClientRect();
        var recorrido = sec.offsetHeight - window.innerHeight;
        var p = lim(-caja.top / Math.max(1, recorrido), 0, 1);
        var f = p * T;
        var esc = Math.min(T - 1, Math.floor(f));
        var q = f - esc;
        var final = esc === T - 1;
        var junta = final ? suave(lim(q * 1.7, 0, 1)) : 0;
        var primera = 0;
        /* Con foto final: ya armado, el aparato se funde en ella */
        var fundido = fotoFinal && final ? suave(lim((q - .55) / .3, 0, 1)) : 0;
        if (fotoFinal) fotoFinal.style.opacity = fundido.toFixed(3);

        piezas.forEach(function (el, i) {
          var suya = i + 1;
          var a = final || esc > suya ? 1 : esc === suya ? suave(lim(q * 2.2, 0, 1)) : 0;
          if (i === 0) primera = a;
          var lejos = 1 + (1 - a) * 1.1;
          var sep = 1 - junta;
          var k = d[i];
          el.style.transform = "translate(" + (k.x * lejos * sep).toFixed(2) + "%," + (k.y * lejos * sep).toFixed(2) + "%) rotate(" + (k.r * sep * lejos).toFixed(2) + "deg)";
          var foco = final || esc === suya;
          el.style.opacity = (a * (foco ? 1 : .42) * (1 - fundido)).toFixed(3);
          el.classList.toggle("is-foco", esc === suya);
        });

        /* La silueta solo acompana la presentacion: se va cuando entra la primera pieza */
        if (fantasma) fantasma.style.opacity = (.18 * (1 - primera)).toFixed(3);
        sec.style.setProperty("--junta", junta.toFixed(3));

        /* Etiqueta junto a la pieza de la escena */
        if (etq) {
          var ip = esc - 1;
          if (ip >= 0 && ip < n && d[ip].etq) {
            var k2 = d[ip];
            var a2 = suave(lim(q * 2.2, 0, 1));
            var lejos2 = 1 + (1 - a2) * 1.1;
            var top = k2.cy + k2.y * lejos2;
            var derecha = k2.der + k2.x * lejos2;
            var izquierda = k2.izq + k2.x * lejos2;
            etq.firstChild.textContent = k2.etq;
            etq.style.top = top.toFixed(2) + "%";
            /* Del lado donde quepa: se mide la etiqueta contra el lienzo
               (que tiene un 14 % de margen a cada lado dentro de la caja) */
            var lienzo = etq.parentNode.clientWidth || 1;
            var anchoEtq = (etq.offsetWidth + 34) / lienzo * 100;
            var cabeDer = derecha + 2 + anchoEtq <= 112;
            var cabeIzq = izquierda - 2 - anchoEtq >= -12;
            etq.classList.remove("is-arriba", "is-abajo");
            if (!cabeDer && !cabeIzq) {
              /* No cabe a ningun lado: encima de la pieza, centrada */
              etq.classList.remove("is-izq");
              var arriba = k2.sup + k2.y * lejos2 - 3;
              var abajo = 2 * k2.cy - k2.sup + k2.y * lejos2 + 3;
              etq.classList.add(arriba < -8 ? "is-abajo" : "is-arriba");
              etq.style.left = ((izquierda + derecha) / 2).toFixed(2) + "%"; etq.style.right = "auto";
              etq.style.top = (arriba < -8 ? abajo : arriba).toFixed(2) + "%";
            } else if (cabeDer && (derecha < 72 || !cabeIzq)) {
              etq.classList.remove("is-izq");
              etq.style.left = (derecha + 2).toFixed(2) + "%"; etq.style.right = "auto";
            } else {
              etq.classList.add("is-izq");
              etq.style.right = (100 - izquierda + 2).toFixed(2) + "%"; etq.style.left = "auto";
            }
            etq.style.opacity = a2.toFixed(3);
          } else {
            etq.style.opacity = "0";
          }
        }

        if (esc !== actual) {
          actual = esc;
          escenas.forEach(function (e, k) { e.classList.toggle("is-activo", k === esc); });
          pasos.forEach(function (b, k) {
            b.classList.toggle("is-activo", k === esc);
            b.setAttribute("aria-current", k === esc ? "step" : "false");
          });
          sec.setAttribute("data-escena", esc === 0 ? "inicio" : final ? "final" : "pieza");
        }
      }

      function pide() { if (!pedido) { pedido = true; requestAnimationFrame(pinta); } }

      pasos.forEach(function (b, k) {
        b.addEventListener("click", function () {
          var recorrido = sec.offsetHeight - window.innerHeight;
          var y = sec.getBoundingClientRect().top + window.pageYOffset + recorrido * ((k + .55) / T);
          window.scrollTo({ top: y, behavior: "smooth" });
        });
      });

      /* La caja es cuadrada y usa todo el escenario que queda libre
         (el que deja el texto en celular o la columna en PC). */
      var escenario = $(".pzl-ens-escenario", sec);
      function mide() {
        if (!escenario) return;
        var lado = Math.floor(Math.min(escenario.clientWidth, escenario.clientHeight));
        if (lado > 0) sec.style.setProperty("--ens-lado", lado + "px");
      }
      if (escenario && "ResizeObserver" in window) new ResizeObserver(mide).observe(escenario);

      cabecera();
      mide();
      window.addEventListener("scroll", pide, { passive: true });
      window.addEventListener("resize", function () { cabecera(); mide(); pide(); });
      pinta();
    });
  }

  /* ---------------------------------------------------------
     ANATOMIA v2 — punto, pestana y tarjeta van juntos. Las
     tarjetas se pasan deslizando (scroll-snap). El avance
     automatico se detiene para siempre en cuanto el cliente toca
     o desliza: a partir de ahi manda el. La pista toma el alto de
     la tarjeta activa para que no quede hueco debajo.
     --------------------------------------------------------- */
  function initAnatomia2(scope) {
    $$("[data-pz-an2]:not([data-pz-an2-listo])", scope).forEach(function (sec) {
      sec.setAttribute("data-pz-an2-listo", "1");
      var pista = $("[data-pz-an2-pista]", sec);
      var slides = $$("[data-pz-an2-slide]", sec);
      var tabs = $$(".pzl-an2-tab", sec);
      var tira = $(".pzl-an2-tabs", sec);
      var puntos = $$(".pzl-anat-punto", sec);
      var marcas = $$(".pzl-an2-puntos i", sec);
      var n = slides.length;
      if (!pista || !n) return;

      var quieto = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var auto = sec.getAttribute("data-auto") === "true" && !quieto;
      var ritmo = (parseFloat(sec.getAttribute("data-ritmo")) || 5) * 1000;
      var activo = 0, tocado = false, visible = false, desdeCodigo = 0, reloj = null;

      /* Todas las tarjetas con el alto de la mas alta: la seccion nunca
         cambia de tamano al pasar de una a otra, asi el navegador no
         mueve la pagina mientras el cliente baja (antes la tarjeta de
         la lima, mas alta, empujaba todo). */
      var anchoMedido = 0;
      function alto(forzar) {
        var ancho = pista.clientWidth;
        if (!forzar && ancho === anchoMedido) return;
        anchoMedido = ancho;
        slides.forEach(function (s) { s.style.minHeight = ""; });
        var max = 0;
        slides.forEach(function (s) { max = Math.max(max, s.offsetHeight); });
        slides.forEach(function (s) { s.style.minHeight = max + "px"; });
      }

      function activa(i, mover) {
        i = (i + n) % n;
        activo = i;
        /* Los modos (6.1, 6.2...) son tarjetas propias, pero pestana y
           punto siguen marcando su Parte (data-parte) */
        var parte = parseInt(slides[i].getAttribute("data-parte"), 10) || 0;
        slides.forEach(function (s, k) { s.classList.toggle("is-activo", k === i); });
        tabs.forEach(function (t, k) {
          t.classList.toggle("is-activo", k === parte);
          t.setAttribute("aria-selected", k === parte ? "true" : "false");
        });
        puntos.forEach(function (p, k) { p.classList.toggle("is-activo", k === parte); });
        marcas.forEach(function (m, k) { m.classList.toggle("is-activo", k === i); });
        /* La pestana activa a la vista, sin mover la pagina */
        var tab = tabs[parte];
        if (tira && tab && tira.scrollWidth > tira.clientWidth) {
          tira.scrollTo({ left: tab.offsetLeft - tira.offsetLeft - (tira.clientWidth - tab.offsetWidth) / 2, behavior: quieto ? "auto" : "smooth" });
        }
        if (mover) {
          desdeCodigo = Date.now();
          pista.scrollTo({ left: slides[i].offsetLeft - pista.offsetLeft - (pista.clientWidth - slides[i].offsetWidth) / 2, behavior: quieto ? "auto" : "smooth" });
        }
      }

      function para() {
        tocado = true;
        clearInterval(reloj);
      }

      $$("[data-pz-an2-ir]", sec).forEach(function (b) {
        b.addEventListener("click", function () { para(); activa(parseInt(b.getAttribute("data-pz-an2-ir"), 10), true); });
      });
      $$("[data-pz-an2-dir]", sec).forEach(function (b) {
        b.addEventListener("click", function () { para(); activa(activo + parseInt(b.getAttribute("data-pz-an2-dir"), 10), true); });
      });

      /* Deslizar con el dedo: la tarjeta mas centrada es la activa */
      var espera = null;
      pista.addEventListener("scroll", function () {
        clearTimeout(espera);
        espera = setTimeout(function () {
          var centro = pista.scrollLeft + pista.clientWidth / 2, mejor = 0, dist = Infinity;
          slides.forEach(function (s, k) {
            var d = Math.abs(s.offsetLeft - pista.offsetLeft + s.offsetWidth / 2 - centro);
            if (d < dist) { dist = d; mejor = k; }
          });
          if (Date.now() - desdeCodigo > 900) para();
          if (mejor !== activo) activa(mejor, false);
        }, 110);
      }, { passive: true });
      pista.addEventListener("pointerdown", para, { passive: true });

      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (e) {
          visible = e[0].isIntersecting;
          if (visible) sec.classList.add("is-visto");
        }, { threshold: 0.35 }).observe(sec);
      } else {
        visible = true;
      }

      if (auto) {
        reloj = setInterval(function () {
          if (tocado || !visible || document.hidden) return;
          activa(activo + 1, true);
        }, ritmo);
      }

      if ("ResizeObserver" in window) new ResizeObserver(function () { alto(false); }).observe(pista);
      window.addEventListener("load", function () { alto(true); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { alto(true); });
      $$("img", pista).forEach(function (im) { if (!im.complete) im.addEventListener("load", function () { alto(true); }, { once: true }); });
      alto(true);
      activa(0, false);
    });
  }

  /* ---------------------------------------------------------
     AHORRO v2 — el grafico se cuenta solo. El HTML trae el
     resultado final; aqui se pone en cero y, cuando la seccion
     entra en pantalla, sube mes a mes: barras, contador del
     gasto, la marca "ya se pago solo" y al final el ahorro.
     --------------------------------------------------------- */
  function initAhorro2(scope) {
    $$("[data-pz-ah2]:not([data-pz-ah2-listo])", scope).forEach(function (caja) {
      caja.setAttribute("data-pz-ah2-listo", "1");
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

      var meses = $$(".pzl-ah2-meses li", caja);
      var gasto = $("[data-pz-ah2-gasto]", caja);
      var ahorro = $("[data-pz-ah2-ahorro]", caja);
      if (!meses.length) return;

      /* Se pone en cero recien cuando la seccion se ve (antes era al
         cargar: si el aviso no llegaba, el grafico quedaba vacio). */
      function prepara() {
        caja.classList.add("is-prep");
        if (gasto) gasto.textContent = "S/ 0";
        if (ahorro) ahorro.textContent = "S/ 0";
        void caja.offsetWidth;
      }

      function cuenta(el, hasta, ms) {
        var t0 = 0;
        function paso(t) {
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / ms);
          el.textContent = "S/ " + Math.round(hasta * (1 - Math.pow(1 - p, 3)));
          if (p < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      }

      function anima() {
        caja.classList.remove("is-prep");
        caja.classList.add("is-anim");
        var i = 0;
        (function siguiente() {
          if (i >= meses.length) {
            caja.classList.add("is-fin");
            if (ahorro) cuenta(ahorro, parseFloat(ahorro.getAttribute("data-final")) || 0, 900);
            return;
          }
          var li = meses[i];
          li.classList.add("is-on");
          if (gasto) {
            gasto.textContent = "S/ " + li.getAttribute("data-acc");
            gasto.classList.remove("is-pulso"); void gasto.offsetWidth; gasto.classList.add("is-pulso");
          }
          if (li.classList.contains("is-hito")) caja.classList.add("is-hito-on");
          i++;
          setTimeout(siguiente, 200);
        })();
      }

      if ("IntersectionObserver" in window) {
        var io = new IntersectionObserver(function (e) {
          if (!e[0].isIntersecting) return;
          io.disconnect();
          prepara();
          setTimeout(anima, 250);
        }, { threshold: 0.3 });
        io.observe(caja);
      } else {
        anima();
      }
    });
  }

  function boot(scope) {
    safe(initSplitText, "splitText", scope);
    safe(initReveals, "reveals", scope);
    safe(initBajar, "bajar", scope);
    safe(initCounters, "counters", scope);
    safe(initFaq, "faq", scope);
    safe(initTesti, "testi", scope);
    safe(initFiltros, "filtros", scope);
    safe(initCarrusel, "carrusel", scope);
    safe(initVideo, "video", scope);
    safe(initSeo, "seo", scope);
    safe(initParallax, "parallax", scope);
    safe(initCtaSeguro, "ctaSeguro", scope);
    safe(initMuro, "muro", scope);
    safe(initGaleria, "galeria", scope);
    safe(initTesti2, "testi2", scope);
    safe(initResenas, "resenas", scope);
    safe(initPartesCf, "partesCf", scope);
    safe(initCifras, "cifras", scope);
    safe(initAntesDespues, "antesDespues", scope);
    safe(initAhorro, "ahorro", scope);
    safe(initComprar, "comprar", scope);
    safe(initAnatomia, "anatomia", scope);
    safe(initEnsamble, "ensamble", scope);
    safe(initAnatomia2, "anatomia2", scope);
    safe(initAhorro2, "ahorro2", scope);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(document); });
  } else {
    boot(document);
  }

  // Editor de temas: al añadir, mover o recargar una sección
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
  document.addEventListener("shopify:block:select", function (e) { boot(e.target); });
})();
